import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const PromoCodeInput = ({ planType, onPromoApplied, planPrice }) => {
  const [promoCode, setPromoCode] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [promoData, setPromoData] = useState(null);
  const [error, setError] = useState('');

  const validatePromoCode = async () => {
    if (!promoCode.trim()) {
      setError('Veuillez entrer un code promo');
      return;
    }

    setIsValidating(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/promo-codes/validate`, {
        code: promoCode.trim().toUpperCase(),
        plan_type: planType
      });

      if (response.data.valid) {
        const discountData = {
          ...response.data,
          originalPrice: planPrice
        };

        // Calculer le montant final
        let discountAmount = 0;
        if (response.data.discount_type === 'percentage') {
          discountAmount = Math.round((planPrice * response.data.discount_value) / 100);
        } else {
          discountAmount = Math.min(response.data.discount_value, planPrice);
        }

        discountData.discountAmount = discountAmount;
        discountData.finalPrice = planPrice - discountAmount;

        setPromoData(discountData);
        onPromoApplied(discountData);
        setError('');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Code promo invalide';
      setError(errorMessage);
      setPromoData(null);
      onPromoApplied(null);
    } finally {
      setIsValidating(false);
    }
  };

  const removePromo = () => {
    setPromoCode('');
    setPromoData(null);
    setError('');
    onPromoApplied(null);
  };

  return (
    <div className="promo-code-section">
      <label className="promo-label">Code Promo (optionnel)</label>
      
      {!promoData ? (
        <div className="promo-input-container">
          <input
            type="text"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
            placeholder="Entrez votre code"
            className="promo-input"
            disabled={isValidating}
          />
          <button
            onClick={validatePromoCode}
            disabled={!promoCode.trim() || isValidating}
            className="promo-validate-btn"
            type="button"
          >
            {isValidating ? '...' : 'Appliquer'}
          </button>
        </div>
      ) : (
        <div className="promo-success">
          <div className="promo-badge">
            <span className="promo-icon">✅</span>
            <span className="promo-text">
              <strong>{promoData.code}</strong> appliqué
              <span className="promo-discount">
                {promoData.discount_type === 'percentage' 
                  ? ` (-${promoData.discount_value}%)`
                  : ` (-${promoData.discount_value} FCFA)`}
              </span>
            </span>
          </div>
          <button onClick={removePromo} className="promo-remove-btn" type="button">
            ✕
          </button>
        </div>
      )}
      
      {error && (
        <div className="promo-error">
          <span className="error-icon">⚠️</span> {error}
        </div>
      )}
    </div>
  );
};

export default PromoCodeInput;
